import { useState } from "react";

export const AwardBadgeIcon = ({
  completed = false,
  gradient = ["#4720B7", "#5AB0D2"],
  gradientColor1 = gradient[0],
  gradientColor2 = gradient[1],
  width = 56,
  height = 62,
  style,
  withIcon,
  iconColor = "#667085",
}) => {
  const [randomId] = useState(Math.random().toString(36).substring(2, 15));

  const iconScale = 1.4;
  const iconX = ((56 - 40) / 2) * iconScale;
  const iconY = ((62 - 44 - 3) / 2) * iconScale;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 56 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g filter={`url(#unique_filter0${randomId})`}>
        {/* fill - gradient or uncompleted */}
        {completed ? (
          <path
            d="M5.5 38.3992V9.40909C5.5 6.69788 7.69788 4.5 10.4091 4.5H45.5909C48.3021 4.5 50.5 6.69788 50.5 9.40909V38.0832C50.5 41.6567 48.5584 44.948 45.4307 46.6764L29.2622 55.6117C27.7103 56.4693 25.8165 56.4235 24.308 55.4917L10.1588 46.7525C7.2629 44.9639 5.5 41.8029 5.5 38.3992Z"
            fill={`url(#unique_paint0_linear${randomId})`}
          />
        ) : (
          <>
            <path
              d="M5.5 38.3992V9.40909C5.5 6.69788 7.69788 4.5 10.4091 4.5H45.5909C48.3021 4.5 50.5 6.69788 50.5 9.40909V38.0832C50.5 41.6567 48.5584 44.948 45.4307 46.6764L29.2622 55.6117C27.7103 56.4693 25.8165 56.4235 24.308 55.4917L10.1588 46.7525C7.2629 44.9639 5.5 41.8029 5.5 38.3992Z"
              fill="white"
            />
            <path
              d="M5.5 38.3992V9.40909C5.5 6.69788 7.69788 4.5 10.4091 4.5H45.5909C48.3021 4.5 50.5 6.69788 50.5 9.40909V38.0832C50.5 41.6567 48.5584 44.948 45.4307 46.6764L29.2622 55.6117C27.7103 56.4693 25.8165 56.4235 24.308 55.4917L10.1588 46.7525C7.2629 44.9639 5.5 41.8029 5.5 38.3992Z"
              fill="#EAECF0"
              fillOpacity="0.5"
            />
          </>
        )}
      </g>
      <path
        opacity="0.2"
        d="M5.5 17.25L47.5 45.75L31.75 54L26.5 56.25L22.75 54.75L16 50.25L7.75 44.25L5.5 40.5V17.25Z"
        fill="#D0D5DD"
      />
      <g filter={`url(#unique_filter1${randomId})`}>
        {/* stroke */}
        <path
          d="M5.5 38.3992V9.40909C5.5 6.69788 7.69788 4.5 10.4091 4.5H45.5909C48.3021 4.5 50.5 6.69788 50.5 9.40909V38.0832C50.5 41.6567 48.5584 44.948 45.4307 46.6764L29.2622 55.6117C27.7103 56.4693 25.8165 56.4235 24.308 55.4917L10.1588 46.7525C7.2629 44.9639 5.5 41.8029 5.5 38.3992Z"
          stroke={completed ? "#4720B7" : "#667085"}
          strokeWidth="1.5"
          shapeRendering="crispEdges"
          strokeOpacity={completed ? 1 : 0.5}
        />
      </g>
      {/* Conditionally render AwardIconInner SVG */}
      {withIcon && (
        <g transform={`translate(${iconX},${iconY}) scale(${iconScale})`}>
          {/* <g opacity="0.5"> */}
          {/* viewBox="0 0 40 44" */}
          <path
            d="M7.91016 20.3182C7.91016 18.9683 7.91016 18.2933 8.32953 17.8739C8.7489 17.4546 9.42386 17.4546 10.7738 17.4546H12.6829C14.0328 17.4546 14.7078 17.4546 15.1272 17.8739C15.5465 18.2933 15.5465 18.9683 15.5465 20.3182V21.2728H7.91016V20.3182Z"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.7266 12.6816V17.4544"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 21.2727H17.4545"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.7168 3.00901L13.7247 5.04145C13.862 5.32437 14.2286 5.59574 14.5378 5.64771L16.3646 5.95373C17.5328 6.15005 17.8077 7.00459 16.9659 7.84759L15.5457 9.27953C15.3052 9.52204 15.1735 9.98969 15.2479 10.3246L15.6545 12.0972C15.9752 13.5003 15.2365 14.0431 14.0052 13.3098L12.2929 12.2878C11.9838 12.103 11.474 12.103 11.1591 12.2878L9.44683 13.3098C8.22132 14.0431 7.47686 13.4945 7.79755 12.0972L8.20414 10.3246C8.2786 9.98969 8.14688 9.52204 7.90636 9.27953L6.48615 7.84759C5.65006 7.00459 5.91922 6.15005 7.08745 5.95373L8.91425 5.64771C9.21776 5.59574 9.58426 5.32437 9.72171 5.04145L10.7296 3.00901C11.2793 1.90618 12.1727 1.90618 12.7168 3.00901Z"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* </g> */}
        </g>
      )}
      <defs>
        <filter
          id={`unique_filter0${randomId}`}
          x="1.5"
          y="1.5"
          width="53"
          height="59.7241"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0"
          />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.1 0"
          />
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
        <filter
          id={`unique_filter1${randomId}`}
          x="0.75"
          y="0.75"
          width="54.5"
          height="61.2241"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0"
          />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.1 0"
          />
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
        {completed && (
          <linearGradient
            id={`unique_paint0_linear${randomId}`}
            x1="-4.625"
            y1="-2.0625"
            x2="65.7946"
            y2="68.5469"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradientColor1} />
            <stop offset="1" stopColor={gradientColor2} />
          </linearGradient>
        )}
      </defs>
    </svg>
  );
};
